// MachineUtilizationDashboard/components/LiveAlertsPanel.jsx

import { useMemo, useState } from "react";
import {
  formatNumber,
  getSeverityClass,
} from "../utils/machineDashboardUtils";

function LiveAlertsPanel({ data = {} }) {
  const [severityFilter, setSeverityFilter] = useState("ALL");

  const filteredAlerts = useMemo(() => {
    const alerts = Array.isArray(data?.alerts) ? data.alerts : [];

    if (severityFilter === "ALL") return alerts;

    return alerts.filter(
      (alert) => String(alert?.severity || "").toUpperCase() === severityFilter,
    );
  }, [data?.alerts, severityFilter]);

  return (
    <div className="mud-alert-panel">
      <div className="mud-alert-summary">
        <div>
          <span>Total</span>
          <strong>{formatNumber(data?.totalAlerts)}</strong>
        </div>

        <div className="critical">
          <span>Critical</span>
          <strong>{formatNumber(data?.criticalAlerts)}</strong>
        </div>

        <div className="warning">
          <span>Warning</span>
          <strong>{formatNumber(data?.warningAlerts)}</strong>
        </div>

        <div className="info">
          <span>Info</span>
          <strong>{formatNumber(data?.infoAlerts)}</strong>
        </div>
      </div>

      <div className="mud-alert-filter">
        {["ALL", "CRITICAL", "WARNING", "INFO"].map((filter) => (
          <button
            type="button"
            key={filter}
            className={severityFilter === filter ? "active" : ""}
            onClick={() => setSeverityFilter(filter)}
          >
            {filter}
          </button>
        ))}
      </div>

      <div className="mud-alert-list">
        {filteredAlerts.length === 0 ? (
          <div className="mud-empty-state">
            No alerts for the selected severity.
          </div>
        ) : (
          filteredAlerts.map((alert, index) => {
            const severityClass = getSeverityClass(alert?.severity);

            return (
              <article
                className={`mud-alert-item mud-alert-item--${severityClass}`}
                key={alert?.alertId || `${alert?.machineCode}---${index}`}
              >
                <span className="mud-alert-item__icon">
                  <i
                    className={`bi ${
                      severityClass === "critical"
                        ? "bi-exclamation-octagon-fill"
                        : severityClass === "warning"
                          ? "bi-exclamation-triangle-fill"
                          : "bi-info-circle-fill"
                    }`}
                  />
                </span>

                <div className="mud-alert-item__body">
                  <div className="mud-alert-item__heading">
                    <div>
                      <strong>{alert?.title || "Machine alert"}</strong>

                      <span>
                        {alert?.machineCode || "-"} · {alert?.deptName || "-"}
                      </span>
                    </div>

                    <span
                      className={`mud-alert-severity mud-alert-severity--${severityClass}`}
                    >
                      {alert?.severity || "INFO"}
                    </span>
                  </div>

                  <p>{alert?.message || "-"}</p>

                  <div className="mud-alert-item__meta">
                    <span>
                      Value: <b>{formatNumber(alert?.value, 2)}</b>
                    </span>

                    <span>
                      Threshold: <b>{formatNumber(alert?.threshold, 2)}</b>
                    </span>

                    <span className="mud-alert-machine-status">
                      {alert?.liveStatus || "-"}
                    </span>
                  </div>
                </div>
              </article>
            );
          })
        )}
      </div>
    </div>
  );
}

export default LiveAlertsPanel;